import { UserDocument } from '../lib/userDocuments.slice'
import { DialogTrigger } from '../shared/confirm-delete-document-dialog/DialogTrigger'
import { Dialog, Table } from '@/ui'

interface ActionCellProps {
  document: UserDocument
}

export const ActionCell = ({ document }: ActionCellProps) => {
  return (
    <Table.Cell className="flex justify-center overflow-visible">
      <Dialog>
        <DialogTrigger document={document} />
      </Dialog>
    </Table.Cell>
  )
}
